import { resetJotaiStore } from '@store/utils/resetGlobalStore';
import Cookies from 'js-cookie';

const REFRESH_TOKEN_KEY = 'ts.session.refreshToken';
const ACCESS_TOKEN_KEY = 'ts.session.accessToken';

const cookieConfig = {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'Strict' as const,
    path: '/',
};

// Cookies manager utilities for non-React contexts (e.g., Apollo Links) without React hooks
export const useCookiesManager = {
    getAccessToken: (): string => {
        return Cookies.get(ACCESS_TOKEN_KEY) ?? '';
    },

    getRefreshToken: (): string => {
        return Cookies.get(REFRESH_TOKEN_KEY) ?? '';
    },

    setAccessToken: (token: string): void => {
        Cookies.set(ACCESS_TOKEN_KEY, token, cookieConfig);
    },

    setRefreshToken: (token: string): void => {
        Cookies.set(REFRESH_TOKEN_KEY, token, cookieConfig);
    },

    setTokens: (accessToken: string, refreshToken: string): void => {
        useCookiesManager.setAccessToken(accessToken);
        useCookiesManager.setRefreshToken(refreshToken);
    },

    hasAccessToken: (): boolean => {
        return Cookies.get(ACCESS_TOKEN_KEY) !== undefined;
    },

    hasRefreshToken: (): boolean => {
        return Cookies.get(REFRESH_TOKEN_KEY) !== undefined;
    },

    clearAccessToken: (): void => {
        Cookies.remove(ACCESS_TOKEN_KEY, { path: cookieConfig.path });
    },

    clearRefreshToken: (): void => {
        Cookies.remove(REFRESH_TOKEN_KEY, { path: cookieConfig.path });
    },

    clearAll: (): void => {
        [REFRESH_TOKEN_KEY, ACCESS_TOKEN_KEY].forEach((key) => {
            Cookies.remove(key, { path: cookieConfig.path });
        });
        void resetJotaiStore();
    },
};
